export const OPERATION_EVENT = {
    MODIFY: 'modify',
    DELETE: 'delete',
};

export const operationConfig = [
    {
        label: '修改',
        event: OPERATION_EVENT.MODIFY,
    },
    {
        label: '删除',
        event: OPERATION_EVENT.DELETE,
    },
];

export const SEX_LIST = [
    {
        label: '男',
        value: 'MALE',
    },
    {
        label: '女',
        value: 'FEMALE',
    },
];

export const FETCH_IMPORT_RESULT_TIME = 5 * 1000; // 5s
export const FETCH_EXPORT_RESULT_TIME = 5 * 1000; // 5s

export const FACE_LIBRARY_MODE_MAP = {
    TOTAL: 'total',
    ATTENDANCE: 'check_in',
    VIP: 'vip',
    VISIT: 'visit',
    OTHERS: 'others',
};

export const TAB_OPTIONS = [
    {
        label: '所有人脸库',
        prop: FACE_LIBRARY_MODE_MAP.TOTAL,
    },
    {
        label: 'VIP库',
        prop: FACE_LIBRARY_MODE_MAP.VIP,
    },
    {
        label: '考勤库',
        prop: FACE_LIBRARY_MODE_MAP.ATTENDANCE,
    },
    {
        label: '来访库',
        prop: FACE_LIBRARY_MODE_MAP.VISIT,
    },
    {
        label: '其他库',
        prop: FACE_LIBRARY_MODE_MAP.OTHERS,
    },
];

export const FACE_LIBRARY_MODE_OPTIONS = [
    { label: '考勤', value: FACE_LIBRARY_MODE_MAP.ATTENDANCE },
    { label: 'VIP', value: FACE_LIBRARY_MODE_MAP.VIP },
    { label: '来访', value: FACE_LIBRARY_MODE_MAP.VISIT },
    { label: '其他', value: FACE_LIBRARY_MODE_MAP.OTHERS },
];

export const VISIT_REASON_MAP = {
    AUDITION: 'interview',
    VISIT: 'visit',
    FIND: 'find',
};

export const VISIT_REASON_OPTIONS = [
    { label: '面试', value: VISIT_REASON_MAP.AUDITION },
    { label: '参观', value: VISIT_REASON_MAP.VISIT },
    { label: '找人', value: VISIT_REASON_MAP.FIND },
];

export const VISIT_REASON_VIEW_MAP = {
    [VISIT_REASON_MAP.AUDITION]: {
        text: '面',
        color: '#2E79F6',
        backgroundColor: '#E1F0FE',
    },
    [VISIT_REASON_MAP.VISIT]: {
        text: '参',
        color: '#EA9E16',
        backgroundColor: '#FFF7D0',
    },
    [VISIT_REASON_MAP.FIND ]: {
        text: '找',
        color: '#4AAB87',
        backgroundColor: '#D9F0E7',
    },
};

export const searchTypeConfig: OptionType[] = [
    {
        label: '全部',
        value: 'all',
    },
    ...VISIT_REASON_OPTIONS,
    {
        label: '到访时间',
        value: 'visitTime',
    },
];
